import React from 'react';
import { CONTENT_BACKUP } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const ChevronRight: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.chevronRight')}</title>
        <g id='web_arrow_right '>
            <path
                id='^ Name above ^'
                d='M10 19L17 12.0185L10 5'
                stroke={CONTENT_BACKUP}
                strokeWidth='1.9'
                strokeLinecap='round'
            />
        </g>
    </svg>
);
